import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { getAuthGateUrl } from '@chegg/one-auth-sdk';
export function fetchCountry() {
  return _fetchCountry.apply(this, arguments);
}
function _fetchCountry() {
  _fetchCountry = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return query(getAuthGateUrl(), {
            query: "{ geolocation { countryCode countryName} }"
          });
        case 2:
          return _context.abrupt("return", _context.sent);
        case 3:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _fetchCountry.apply(this, arguments);
}
function query(_x, _x2) {
  return _query.apply(this, arguments);
}
function _query() {
  _query = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(url, data) {
    var response, parsedResponse, errorData;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return fetch(url, {
            credentials: 'include',
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json'
            },
            method: 'POST',
            body: JSON.stringify(data)
          });
        case 2:
          response = _context2.sent;
          _context2.next = 5;
          return response.json();
        case 5:
          parsedResponse = _context2.sent;
          if (response.ok) {
            _context2.next = 9;
            break;
          }
          errorData = parsedResponse && JSON.stringify(parsedResponse);
          throw new Error(errorData);
        case 9:
          return _context2.abrupt("return", parsedResponse);
        case 10:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return _query.apply(this, arguments);
}